export const useBottomTabBarHeight = () => 0
